import { apiUrl } from '../../../config/api';
export async function fetchRecordsData() {
    const [resRecords, resRecordsPromedios, resMaximos,
        resPromTemporada] = await Promise.all([
            fetch(apiUrl('recordsTotales/records')),
            fetch(apiUrl('recordsPromedios/records')),
            fetch(apiUrl('maximos/records')),
            fetch(apiUrl('recordsTemporada')),
        ]);

    const records = await resRecords.json();
    const recordsPromedios = await resRecordsPromedios.json();
    const maximos = await resMaximos.json();

    return Promise.all([
        records.partidos, records.ganados, records.min, records.pts, records.rt, records.ast, records.stl, records.bls,
        recordsPromedios.min, recordsPromedios.pts, recordsPromedios.rt, recordsPromedios.ast, recordsPromedios.stl, recordsPromedios.bls, records.tcperc, records.tlperc, records.tdperc, records.ttperc,
        maximos.puntos, maximos.rebotesTot, maximos.asistencias, maximos.robos, maximos.tapas, maximos.libresHechos, maximos.doblesHechos, maximos.triplesHechos,
        resPromTemporada.json(), records.partidosDT, records.ganadosDT, records.winPercDT
    ]);
}
